import * as React from "react";
import { Icon, Stack, Text } from "office-ui-fabric-react";

const requirementItems = ["You are a third-party provider of certified planning software", "You accept and upload the mandatory legal agreement"];

export const AccessRequirements = (): React.ReactElement => {
  return (
    <Stack className="welcomeInfoCard access-requirements" tokens={{ childrenGap: 16 }}>
      <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 12 }}>
        <Icon iconName="Lock" className="welcomeInfoCardIcon" />
        <Text variant="xLarge" className="welcomeInfoCardTitle">
          Access Requirements
        </Text>
      </Stack>
      <ul className="welcomeInfoList">
        {requirementItems.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </Stack>
  );
};
